import { Navigate } from "react-router-dom";
import AuthCheckLoader from "./loader/AuthCheckLoader";
import { useAuth } from "@/auth/AuthContext";

interface PublicRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

const PublicRoute: React.FC<PublicRouteProps> = ({
  children,
  redirectTo = "/dashboard",
}) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <AuthCheckLoader />;
  }

  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
